import { resolve } from 'redux-optimist-promise';
import {
  FETCH_PROPOSALS_BY_ID,
  FETCH_PROPOSALS,
  FETCH_PROPOSALS_FROM_EDIT_CRITERIA,
} from 'Store/booking/proposals/constants';
import { UPDATE_VALIDATION_SCHEMA } from 'Store/validation-schema/constants';
import { ATTENDEES_ROLES } from './validationSchema.selectors';
export type State = { [key in any]?: Array<ValidationSchema> } & {
  address: Array<ValidationSchema>;
};
const initialState = {
  address: [],
  [ATTENDEES_ROLES.MAIN]: [],
  [ATTENDEES_ROLES.OTHER_ADULT]: [],
  [ATTENDEES_ROLES.KID]: [],
};

const validationMapper = (validation) => ({
  ...validation,
  validators: validation.validators.map((validator) =>
    validator.name === 'pattern'
      ? {
          name: 'pattern',
          value: new RegExp(validator.value),
        }
      : validator,
  ),
});

const reducer = (state: State = initialState, action: Action<any>): State => {
  switch (action.type) {
    case resolve(FETCH_PROPOSALS):
    case resolve(FETCH_PROPOSALS_BY_ID):
    case resolve(FETCH_PROPOSALS_FROM_EDIT_CRITERIA):
    case UPDATE_VALIDATION_SCHEMA: {
      const validationSchema = action.payload?.validationSchema;

      if (!validationSchema) {
        return state;
      }

      const newState = { ...initialState };
      validationSchema.forEach((validationSchemaItem) => {
        newState[validationSchemaItem.name] =
          validationSchemaItem?.fields
            ?.map(validationMapper)
            ?.filter(({ type }) => type === 'string') || [];
      });
      return newState;
    }

    default:
      return state;
  }
};

export default reducer;
